import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type {
	DeleteSlackConnectSettings,
	UpdateSlackConnectSettings,
} from "../types"

export const SAME_CHANNEL_ERROR =
	"Pick a channel other than the one new threads go to."

export const slackConnectSettingsMutators = {
	update: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: UpdateSlackConnectSettings
		}) => {
			let importantNotificationChannelId = args.importantNotificationChannelId
			if (args.importantNotificationChannelId || args.notificationChannelId) {
				const current = await tx.query.slackConnectSettings
					.where("id", args.id)
					.one()
					.run()
				const newThreadsChannel =
					args.notificationChannelId !== undefined
						? args.notificationChannelId
						: current?.notificationChannelId
				if (
					args.importantNotificationChannelId &&
					newThreadsChannel === args.importantNotificationChannelId
				) {
					throw new Error(SAME_CHANNEL_ERROR)
				}
				if (
					importantNotificationChannelId === undefined &&
					newThreadsChannel &&
					newThreadsChannel === current?.importantNotificationChannelId
				) {
					importantNotificationChannelId = null
				}
			}
			await tx.mutate.slackConnectSettings.update({
				id: args.id,
				pushBotReply: args.pushBotReply,
				pushBotReplyChannel: args.pushBotReplyChannel,
				notificationChannelId: args.notificationChannelId,
				importantNotificationChannelId,
				mutedInboxChannelIds: args.mutedInboxChannelIds,
				type: args.type,
				groupingWindowMinutes: args.groupingWindowMinutes,
				channelWelcomeEnabled: args.channelWelcomeEnabled,
				channelWelcomeMessage: args.channelWelcomeMessage,
				communityWelcomeEnabled: args.communityWelcomeEnabled,
				communityWelcomeMessage: args.communityWelcomeMessage,
				newChannelsInbox: args.newChannelsInbox,
				linearAsksMode: args.linearAsksMode,
				updatedAt: Date.now(),
			})
		},
	),
	delete: defineMutator(
		async ({
			tx,
			args,
		}: {
			tx: MutatorTx
			args: DeleteSlackConnectSettings
		}) => {
			await tx.mutate.slackConnectSettings.delete({ id: args.id })
		},
	),
}
